import { render, staticRenderFns } from "./employees.vue?vue&type=template&id=225a3b07&scoped=true&"
import script from "./employees.vue?vue&type=script&lang=js&"
export * from "./employees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225a3b07",
  null
  
)

export default component.exports